import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { AuthProvider } from 'react-oidc-context';
import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { theme } from './theme';
import { DialogProvider } from './context/useDialog';
import { ThemeProvider } from '@mui/material';
import { ApiContextProvider } from './context/useApi';
import { MessageProvider } from './context/useMessage';
import { LoggedContextProvider } from './context/useLogged';

const cognitoAuthConfig = {
  authority: 'https://cognito-idp.eu-south-1.amazonaws.com/eu-south-1_liH51Sh3G',
  client_id: '3iknn11eolagucn5u36i4m82jj',
  redirect_uri: 'https://entitymatch.gksdprocure.com/',
  // redirect_uri: 'http://localhost:3000/',
  response_type: 'code',
  scope: 'email openid profile',
  post_logout_redirect_uri: 'https://entitymatch.gksdprocure.com/logout',
  // post_logout_redirect_uri: 'http://localhost:3000/logout',

  extraQueryParams: {
    prompt: 'login', // Forza sempre il login
    max_age: '0', // Non usare sessioni cached
  },

  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

const queryClient = new QueryClient();
const root = createRoot(document.getElementById('root')!);
root.render(
  <AuthProvider {...cognitoAuthConfig}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <StyledThemeProvider theme={theme}>
          <ApiContextProvider>
            <CookiesProvider>
              <BrowserRouter>
                <LoggedContextProvider>
                  <MessageProvider>
                    <DialogProvider>
                      <App />
                    </DialogProvider>
                  </MessageProvider>
                </LoggedContextProvider>
              </BrowserRouter>
            </CookiesProvider>
          </ApiContextProvider>
        </StyledThemeProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </AuthProvider>,
);
